import { Skeleton } from "@/components/ui/baseUi/skeleton"
import { BoxStaffCoachIcon } from "@images/svgIcons/boxStaff/boxStaffCoachIcon"
import { BoxStaffCoOwnerIcon } from "@images/svgIcons/boxStaff/boxStaffCoOwnerIcon"
import { BoxStaffFinancialIcon } from "@images/svgIcons/boxStaff/boxStaffFinancialIcon"
import { BoxStaffHeadCoachIcon } from "@images/svgIcons/boxStaff/boxStaffHeadCoachIcon"
import { BoxStaffOwnerIcon } from "@images/svgIcons/boxStaff/boxStaffOwnerIcon"
import { BoxStaffRole } from "@modules/boxStaff/gateway/boxStaffDto"
import { word } from "@modules/core/utils/i18n"

export function displayIcon(
  colorClassName: string,
  size: number,
  sizeClassName: string,
  role?: BoxStaffRole,
): React.JSX.Element {
  const icons = {
    OWNER: <BoxStaffOwnerIcon color="currentColor" size={size} className={colorClassName} />,
    CO_OWNER: <BoxStaffCoOwnerIcon color="currentColor" size={size} className={colorClassName} />,
    HEAD_COACH: <BoxStaffHeadCoachIcon color="currentColor" size={size} className={colorClassName} />,
    COACH: <BoxStaffCoachIcon color="currentColor" size={size} className={colorClassName} />,
    FINANCIAL: <BoxStaffFinancialIcon color="currentColor" size={size} className={colorClassName} />,
    READ_ONLY: <></>,
  }
  if (!role) return <Skeleton className={`rounded-full ${sizeClassName}`} />
  return icons[role]
}

export function displayRole(role: BoxStaffRole): string {
  const roles = {
    OWNER: word("staff.role.owner"),
    CO_OWNER: word("staff.role.co_owner"),
    HEAD_COACH: word("staff.role.head_coach"),
    COACH: word("staff.role.coach"),
    FINANCIAL: word("staff.role.financial"),
    READ_ONLY: "",
  }
  return roles[role]
}
